import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAppContext } from "../Libs/contextLib";
import { isUserAdmin } from "../Libs/helperLib";

export default function AdminRoute({ component: C, appProps, ...rest }) {
	const { isAuthenticated, currUser } = useAppContext();
	return (
		<Route
			{...rest}
			render={(props) =>
				isAuthenticated && isUserAdmin(currUser) ? (
					<C {...props} {...appProps} />
				) : (
					<Redirect
						to={`/Error?redirect=${props.location.pathname}${props.location.search}`}
					/>
				)
			}
		/>
	);
}
